import { action, makeAutoObservable, observable } from "mobx"
import { moduleIds } from "@lib/appconst"
import appDataService from "@services/appDataService"
import unitTypeService from "@services/master-data/unitTypeService"
import customerSourceService from "@services/master-data/customerSourceService"
import propertyTypeService from "@services/master-data/propertyTypeService"
class AppDataStore {
  @observable isLoading!: boolean
  @observable countries!: any
  @observable nationality!: any
  @observable departments!: any

  @observable opportunityStatus!: any
  @observable unitTypes!: any
  @observable unitTypeChilds!: any
  @observable unitStatus!: any
  @observable leadSource!: any
  @observable documentTypes!: any

  @observable paymentStatus!: any

  // Project
  @observable propertyTypes!: any

  @observable facilities!: any
  @observable grades!: any

  @observable transportations!: any
  @observable clients: any[] = []
  @observable contacts: any[] = []
  @observable inquiryStatus: any[] = []
  @observable inquirySubStage: any[] = []
  @observable inquirySubStageByStage: any[] = []
  // CRM
  @observable sources!: any[]
  @observable potentialChannel!: any[]
  @observable carts!: any[]

  // Master data
  @observable townships: any = []
  @observable projects: any = []
  @observable units: any = []

  @observable towers: any = []
  @observable zones: any = []
  @observable floors: any = []
  @observable projectFacilities: any = []
  @observable unitFacilities: any = []
  @observable inquiryTypes: any = []

  @observable unitDesigns: any = []
  @observable listEmployee: any = []

  @observable listCartTemplateSms: any = []
  @observable listCartTemplateEmail: any = []
  @observable agencyMasters: any = []
  @observable listBookingStatus: any = []

  // Unit
  @observable facing: any = []
  @observable view: any = []

  //contract
  @observable listContract: any = []
  @observable listContractType: any = []
  @observable listPaymentProgress: any = []
  @observable listSalePolicy: any = []
  @observable listCompany: any = []

  @observable listPrintTemplate: any = []

  //accounting data
  @observable accountTypes: any = []
  @observable offsetAccountParents: any = []

  @observable listOffsetAccount: any = []
  @observable listCostCenter: any = []
  @observable listGroup: any = []

  constructor() {
    makeAutoObservable(this)
    // this.getDepartments({});
    this.carts = []
  }

  // Sàn (AgencyMaster) active đầu tiên - dùng làm giá trị mặc định ở mọi nơi liên quan đến sàn
  get defaultAgencyMasterId() {
    const list = this.agencyMasters || []
    if (!list.length) return undefined
    const active = list.find((i) => i.isActive === true)
    if (active) return active.value ?? active.id
    // Nếu API đã trả về sẵn danh sách active (item không có cờ isActive) thì lấy phần tử đầu tiên
    const hasActiveFlag = list.some((i) => typeof i.isActive === "boolean")
    return hasActiveFlag ? undefined : list[0].value ?? list[0].id
  }

  @action
  async getListAgencyMaster(params?: any) {
    const res = await appDataService.GetListAgencyMaster(params)
    this.agencyMasters = (res || []).map((i) => ({
      ...i,
      value: i.value ?? i.id,
      label: i.label ?? i.name,
    }))
  }

  @action getInquirySourceAndStatus = async () => {
    const res = await appDataService.getInquirySourceAndStatus()
    this.inquiryStatus = res.filter((item) => item.code === "InquiryStatus")
    this.inquirySubStage = res.filter((item) => item.code === "InquiryStage")
  }

  @action getInquirySubStage = async (id) => {
    this.inquirySubStageByStage = this.inquirySubStage.filter(
      (item) => item.parentId === id
    )
  }

  @action getClients = async (keyword) => {
    this.clients = await appDataService.getClients(keyword)
  }
  @action getContacts = async (keyword) => {
    this.contacts = await appDataService.getContacts(keyword)
  }

  @action
  async getCountries(params) {
    const res = await appDataService.getCountries(params)

    this.countries = (res || []).map((item) => {
      item.phoneCodeName = `${item.countryCode} (+${item.phoneCode})`
      item.name = item.countryName
      item.label = item.countryName
      item.value = item.id
      item.isLeaf = false // for Cascader
      return item
    })
    this.nationality = (res || []).map((item) => {
      item.phoneCodeName = `${item.countryCode} (+${item.phoneCode})`
      item.name = item.nationalityName
      item.label = item.nationalityName
      item.value = item.id
      item.isLeaf = false // for Cascader
      return item
    })
  }

  @action
  async getDepartments(params) {
    this.departments = await appDataService.getDepartments(params)
  }

  @action
  async getDocumentType(params) {
    const res = await appDataService.getDocumentType(params)
    const rel = res.filter((item) => item.id !== 8)
    this.documentTypes = rel.map((item) => {
      return { id: item?.id, value: item?.id, label: item?.name }
    })
  }

  //PMH
  //Unit
  @action async GetListUnitStatus(keyword) {
    const res = await appDataService.GetListUnitStatus(keyword)
    this.unitStatus = res
  }

  @action async GetListLeadSource(keyword) {
    this.leadSource = await appDataService.GetListLeadSource(keyword)
  }
  //project
  @action async GetListPropertyType(keyword) {
    this.propertyTypes = await propertyTypeService.getList({ keyword })
  }
  @action async GetListView() {
    this.view = await appDataService.GetListView()
  }

  // MasterData
  @action
  async getListUnitType(params?: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.unitTypes = result
  }

  @action
  async getListUnitTypeChild(params?: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getListChildren(params)
      .finally(() => (this.isLoading = false))
    this.unitTypeChilds = result
  }
  @action async getListTownShip(params?: any) {
    this.townships = await appDataService.GetListTownShip(params)
  }

  @action async getListProject() {
    const res = await appDataService.getListProject()
    this.projects = res.map((i) => {
      return {
        ...i,
        label: i.projectName,
      }
    })
  }
  @action async getListUnit(params?: any) {
    const res = await appDataService.getListUnit(params)
    this.units = res.map((i) => {
      return {
        ...i,
        label: i.unitName,
      }
    })
  }
  @action async getListTower() {
    this.towers = await appDataService.GetListTower()
  }

  @action async getListZone() {
    this.zones = await appDataService.GetListZone()
  }
  @action async getListFloor() {
    this.floors = await appDataService.GetListFloor()
  }

  @action async GetListUnitFacility() {
    this.unitFacilities = await appDataService.GetListUnitFacility()
  }
  @action async GetListInquiryType() {
    const res = await appDataService.GetListInquiryType()
    this.inquiryTypes = res
  }
  @action async GetListUnitDesign() {
    this.unitDesigns = await appDataService.GetListUnitDesign()
  }

  @action async GetListProjectFacility() {
    this.projectFacilities = await appDataService.GetListProjectFacility()
  }

  @action async getListEmployee(params?: any) {
    this.listEmployee = await appDataService.getListEmployee(params)
  }
  @action async getListCartTemplateEmail(moduleId?: number) {
    this.listCartTemplateEmail = await appDataService.getListCartTemplate({
      module: moduleId || moduleIds.cartEmail,
    })
  }
  @action async getListCartTemplateSms() {
    this.listCartTemplateSms = await appDataService.getListCartTemplate({
      module: moduleIds.cartSms,
    })
  }

  // CRM
  @action
  async getListSource() {
    const res = await customerSourceService.getList()
    this.sources = res
  }

  @action async getListCompany(params?) {
    const result = await appDataService.getListCompany(params)
    this.listCompany = result || []
  }
}

export default AppDataStore
